import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import "./c97_fact_cards.scss"
import InnerHTML from 'dangerously-set-html-content';
import Slider from "react-slick";


class C97FactCards extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
            isHidden: true,
            btnHidden: '',
            dataIndex: null,
            disabled: false,
            slideIndex: 1,
            updateCount: 0
        };

        this.requireInternationalization = true;
        //this.dataUrl = this.dataUrl.replace('https://ho4out7of9.execute-api.eu-west-1.amazonaws.com/prod', 'https://www.luiss.it')

    };

    internationalComponentRender(data, t) {


        const cards = data.cards.map((card, index)=>
            <div className="fact-card-container" key={index}>
                <div className="fact-card" >
                    <div className="fact-card-title">
                        <div id={index}>{card.title}</div>
                    </div>
                    <div className="fact-card-body">
                    <InnerHTML html={card.content}/>
                    </div>
                </div>
                <div className="button-container">          <button><a style={{color:'#003A70'}} href={card.link_url}>{card.link_title} </a></button></div>
            </div>
        )

        const sliderSettings = {
            arrows: false,
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 5, //to change to cards.count()
            slidesToScroll: 0,

            responsive: [
                {
                    breakpoint: 1810,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 3.5,
                        slidesToScroll: 2,

                    }
                },
                {
                    breakpoint: 1290,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 2.5,
                        slidesToScroll: 2,

                    }
                },
                {
                    breakpoint: 930,
                    settings: {
                        arrows: false,
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: 1.5,
                        slidesToScroll: 1,
                        centerMode: true,
                        centerPadding: '-25px',
                    }
                }
            ]

            // beforeChange: (currIndex, nextIndex) => {
            //     // We cannot change the state, or the rerender won't let the slider component to work properly
            //     this.setState({active: nextIndex});
            // }
        };

        return (<>
            <div className="fact-cards">
                <Slider {...sliderSettings}>
                        {cards.map((card,index)=>{return <div key={index}>{card}</div>})}
                </Slider>
            </div>

        </>
        )
    }
}

export default C97FactCards;